/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import useCalendarOnBoard from "./useCalendarOnBoard";
import "./CalenderOnBoard.scss";
export default (props) => {
  const {
    calendarLinked,
    googleLoader,
    formInputsError,
    userMeta,

    google_login,
  } = useCalendarOnBoard(props);
  return (
    <div className="calender-onboard-wrapper">
      {userMeta?.id && (
        <>
          {calendarLinked && (
            <>
              {calendarLinked.data === true ? (
                <div className="calender-onboard py-5">
                  <div className="container">
                    <div className="inner bg-white text-center py-5 border-radius-15 shadow">
                      <img src="/assets/images/logo.png" alt="logo" />

                      <div className="text-center bg-grey-2 d-flex align-items-center connect-google-wrapper">
                        <div className="icon mr-4">
                          <img
                            src={"/assets/images/google-calender.png"}
                            alt="google calender icon"
                          />
                        </div>
                        <p className="mb-0 font-weight-bold">Google Calender</p>
                        <button className="btn btn-primary ml-auto">
                          Google Calender Linked{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="calender-onboard py-5">
                  <div className="container">
                    <div className="inner bg-white text-center py-5 border-radius-15 shadow mt-5">
                      <div className="mb-3">
                        <img src="/assets/images/logo.png" alt="logo" />
                      </div>
                      <h1 className="text mb-4">Welcome Onboard !</h1>
                      <p className="px-3">
                        Let hiring managers know your availability and schedule
                        interviews with you with a click of a button. Get your
                        very own calendar availability link.
                      </p>
                      <div className="text-center bg-grey-2 p-3 m-3">
                        <p>
                          Jigsaw’s use and transfer to any other app of
                          information received from Google APIs will adhere to{" "}
                          <a
                            href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
                            target="_blank"
                            rel="noreferrer"
                            className="text-primary"
                          >
                            Google API Services User Data Policy
                          </a>
                          , including the Limited Use requirements.
                        </p></div>
                     
                        <div className="text-center bg-grey-2 d-flex align-items-center connect-google-wrapper">
                          <div className="icon mr-4">
                            <img
                              src={"/assets/images/google-calender.png"}
                              alt="google calender icon"
                            />
                          </div>
                          <p className="mb-0 font-weight-bold">
                            Google Calender
                          </p>

                          <button
                            className="btn btn-primary ml-auto"
                            onClick={(e) => google_login()}
                          >
                            Connect with Google Calender
                          </button>
                        </div>
                      
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};
